import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverScheduleRoutingModule } from './driver-schedule-routing.module';
import { ScheduleComponent } from './components/schedule/schedule.component';
import { DriverScheduleComponent } from './driver-schedule.component';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { CreateScheduleComponent } from './components/create-schedule/create-schedule.component';
import { DriverScheduleService } from './driver-schedule.service';
import { VehiclesService } from '../vehicles/vehicles.service';
import { UsersService } from '../users/users.service';
import { TextMaskModule } from 'angular2-text-mask';
import { DriversService } from '../drivers/drivers.service';
import { ProgressBarModule } from 'app/utils/progress-bar/progress-bar.module';
import { CreateDateRangeComponent } from './components/create-date-range/create-date-range.component';
import { HistoryScheduleComponent } from './components/history-schedule/history-schedule.component';
import {DirectivesModule} from '../../directives/directives.module';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';

@NgModule({
  imports: [
    CommonModule,
    DriverScheduleRoutingModule,
    Trip2ThemeModule,
    MyDateRangePickerModule,
    FormsModule,
    AgGridModule.withComponents([BooleanCheckComponent]),
    GridComponentsModule,
    ReactiveFormsModule,
    TextMaskModule,
    ProgressBarModule,
    DirectivesModule
  ],
  declarations: [DriverScheduleComponent,
    ScheduleComponent,
    CreateScheduleComponent,
    CreateDateRangeComponent,
    HistoryScheduleComponent],
  exports: [DriverScheduleComponent,
    ScheduleComponent,
    CreateScheduleComponent,
    CreateDateRangeComponent,
    HistoryScheduleComponent],
  providers: [
    DriverScheduleService,
    UsersService,
    VehiclesService,
    DriversService
  ]
})
export class DriverScheduleModule { }




// WEBPACK FOOTER //
// ./src/app/pages/driver-schedule/driver-schedule.module.ts